import React from 'react';
import { LocCtn, SvgCtn } from './index.style';

import ICONS from '../../assets/icons';
import useTextCorrection from '../../hooks/useTextCorrection';

interface SlaProps {
  location?: string;
}

const LocationLabel: React.FC<SlaProps> = ({ location }): React.ReactElement => {
  const { titleCase } = useTextCorrection();

  return (
    <LocCtn>
      <SvgCtn>
        <ICONS.mapPin />
      </SvgCtn>
      <span>{titleCase(location)}</span>
    </LocCtn>
  );
};

export default LocationLabel;
